/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** The severity of the response */
export enum ResponseDetailSeverity {
  Info = "Info",
  Warning = "Warning",
  Error = "Error",
}

/** Possible result statuses in SDC */
export enum MasterDataExchangeStatus {
  NotReceived = "NotReceived",
  Received = "Received",
  Onhold = "Onhold",
  Stored = "Stored",
  Completed = "Completed",
  CompletedWithWarning = "CompletedWithWarning",
  Failed = "Failed",
  Cancelled = "Cancelled",
}

/** Details about the response. */
export interface EnrichedResponseDetail {
  /**
   * Specific code of response in destination
   * @minLength 1
   */
  responseCode: string;
  /** The severity of the response */
  severity: ResponseDetailSeverity;
  /** Descriptions dictionary for the provided codes, with an entry for every language key */
  descriptions: EnrichedResponseDetailDescriptions[];
  /** The entities/fields the response is related to */
  targets?: string[] | null;
  /** Specific code of resolution in destination */
  resolutionCode?: string | null;
  /** Generic code defined centrally in sdconnect */
  genericCategoryCode?: string | null;
  [key: string]: any;
}

/** Descriptions for a response. */
export interface EnrichedResponseDetailDescriptions {
  /**
   * Specifies a language identifier following the BCP 47 standard, used to represent languages and their regional variations. This tag consists of a two-letter ISO 639-1 language code (e.g., en for English, de for German) and may include an optional ISO 3166-1 alpha-2 country code (e.g., en-GB for British English, fr-FR for French in France).
   * @minLength 1
   */
  languageTag: string;
  /** The description for the ResponseCode if provided */
  responseDescription?: string | null;
  /** The description for the GenericCategoryCode if provided */
  genericCategoryDescription?: string | null;
  /** The description for the resolution if provided */
  resolutionDescription?: string | null;
  [key: string]: any;
}

/**
 * Details about the error.
 * @example "null"
 */
export interface InnerErrorDetails {
  /** Code */
  code?: string | null;
  /** Details about the error. */
  innerError?: InnerErrorDetails;
  [key: string]: any;
}

/** The message body with the destination callback sent to the source system */
export interface MasterDataCallbackRequest {
  /** Trace id of the original request */
  traceId: string;
  /** Sub affiliate master id of the original request */
  subAffiliateMasterId: string;
  /** Person identifier of the original request */
  personIdentifier?: string | null;
  /** Source correlation id of the original request */
  sourceCorrelationId?: string | null;
  /** Possible result statuses in SDC */
  status: MasterDataExchangeStatus;
  /** CDM object with the impacted records (in their updated form) after processing */
  result?: any;
  /** Deprecated: Collection of informational messages from the destination */
  remarks?: string[] | null;
  /**
   * Estimation of when a data flow will be processed.
   * @format date-time
   */
  expectedResolutionTime?: string | null;
  /** An optional parameter that destination systems can provide to specify the current location of the message. This can be a queuename, database name or any other storage location */
  messageLocation?: string | null;
  /** An optional parameter that destination systems can provide to correlate the callback to their own system */
  destinationCorrelationId?: string | null;
  /** Details about the error. */
  error?: ErrorDetails;
  /** Collection of informational, warning and error messages from the destination */
  responses?: EnrichedResponseDetail[] | null;
  [key: string]: any;
}

/** Error response with trace identifier */
export interface ErrorResponse {
  /** The traceId */
  traceId: string;
  /** Details about the error. */
  error?: ErrorDetails;
}

/** Details about the error. */
export interface ErrorDetails {
  /** Optional: Error code */
  code?: string | null;
  /** Optional: Readable error message */
  message?: string | null;
  /** Optional: Specifies a language identifier following the BCP 47 standard, used to represent languages and their regional variations. This tag consists of a two-letter ISO 639-1 language code (e.g., en for English, de for German) and may include an optional ISO 3166-1 alpha-2 country code (e.g., en-GB for British English, fr-FR for French in France). */
  languageTag?: string | null;
  /** Optional: Target where the error came from */
  target?: string | null;
  /**
   * Optional: More details about the error
   * @example "[]"
   */
  details?: ErrorDetails[] | null;
  /** Details about the error. */
  innerError?: InnerErrorDetails;
  /** Specific details about a suggested resolution the destination system proposes */
  resolution?: Resolution;
}

/** Response for the master data request */
export interface MasterDataResponse {
  /** Unique id to correlate future operation updates */
  traceId: string;
  /** CDM object with the impacted records (in their updated form) after processing */
  result?: any;
  /** Deprecated: Collection of informational messages from the destination */
  remarks?: string[] | null;
  /**
   * Estimation of when a data flow will be processed.
   * @format date-time
   */
  expectedResolutionTime?: string | null;
  /** An optional parameter that destination systems can provide to specify the current location of the message. This can be a queuename, database name or any other storage location */
  messageLocation?: string | null;
  /** An optional parameter that destination systems can provide to correlate the callback to their own system */
  destinationCorrelationId?: string | null;
  /** Collection of informational, warning and/or error messages from the destination */
  responses?: EnrichedResponseDetail[] | null;
  [key: string]: any;
}

/** Specific details about a suggested resolution the destination system proposes */
export interface Resolution {
  /** Specific resolution code about this exact error */
  code: string;
  /** Message about the resolution action */
  message: string;
}
